import React from 'react';
import cn from 'classnames';
import { Grid, GridItem, Link } from '@landing/ui';
import { Container } from 'components/UI';
import { replaceKeyword } from 'utils';
import * as styles from './Statistics.module.scss';

const defineTextWrapper = (href, className, children, loading) => {
  return href ? (
    <Link href={href} className={className}>
      {!loading ? children : ''}
    </Link>
  ) : (
    <div className={className}>{!loading ? children : ''}</div>
  );
};

export default function Statistics({
  items = [],
  gutterX = '20px',
  gutterY = '40px',
  colsXsm = 2,
  colsSm = 2,
  colsMd = 4,
  colsLg = 4,
  loading = false,
}) {
  return (
    <Container>
      <div className={styles.layout}>
        <Grid
          xsm={{ cols: colsXsm }}
          sm={{ cols: colsSm }}
          md={{ cols: colsMd }}
          lg={{ cols: colsLg }}
          xl={{ cols: colsLg }}
          gutterY={gutterY}
          gutterX={gutterX}
        >
          {items.map(({ number, text, href }, i) => (
            <GridItem key={i}>
              <div className={styles.card}>
                <div className={cn(styles.number, loading && styles.skeleton)}>
                  {!loading ? replaceKeyword(number) : ''}
                </div>
                {defineTextWrapper(
                  href,
                  cn(styles.text, href && styles.link, loading && styles.skeleton),
                  text,
                  loading,
                )}
              </div>
            </GridItem>
          ))}
        </Grid>
      </div>
    </Container>
  );
}
